import { use } from 'react'
import { Navigate } from 'react-router'
import { AuthContext } from '@/components/auth/context'

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = use(AuthContext) ?? {}

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}
